import { FC } from 'react'

import TrainingCategoryFormFields from './training-category-form-fields'

import { ITrainingCategoryFormProps } from './training-category-form-types'

const TrainingCategoryForm: FC<ITrainingCategoryFormProps> = props => {
  const { handleSubmit, formName, submitting } = props

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <TrainingCategoryFormFields disabled={submitting} />
    </form>
  )
}

export default TrainingCategoryForm
